import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@portal/platform/guards';
import { CallQueue } from '@/features/leads/call-script/call-queue';
import { LeadsPage } from '@/features/leads/leads-page';

interface LeadsSearch {
  /** `table`: the classic grid, kept as a second view. The call queue is the default. */
  view?: 'table';
}

/**
 * The leads follow-up queue: the legacy portal's AltDesign call queue by default, the classic
 * table behind `?view=table`. Its list endpoint requires `lead:read`.
 */
export const Route = createFileRoute('/_app/leads')({
  staticData: { featureKey: 'leads' },
  validateSearch: (search: Record<string, unknown>): LeadsSearch =>
    search['view'] === 'table' ? { view: 'table' } : {},
  beforeLoad: ({ context, location }) =>
    requireFeature(context, location, { feature: 'leads', permissions: ['lead:read'] }),
  component: Leads,
});

function Leads() {
  const { view } = Route.useSearch();
  return view === 'table' ? <LeadsPage /> : <CallQueue />;
}
